import { render, staticRenderFns } from "./CommonPanelWithExpandable.vue?vue&type=template&id=7768af40&lang=pug&"
import script from "./CommonPanelWithExpandable.vue?vue&type=script&lang=ts&"
export * from "./CommonPanelWithExpandable.vue?vue&type=script&lang=ts&"
import style0 from "./CommonPanelWithExpandable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports